<template>
  <div class="liu-xuan-course-info">
    <template v-if="status === 'warmUp'">
      <img class="course"
           :src="require('@/assets/img/liuxuan-psychology/warm-up/course.png')"
           alt=""
      />
    </template>
    <template v-if="status === 'firstPart'">
      <img class="course course-first"
           :src="require('@/assets/img/liuxuan-psychology/second-stage/course01.png')"
           alt=""
      /><img class="course"
             :src="require('@/assets/img/liuxuan-psychology/second-stage/course02.png')"
             alt=""
    />
    </template>
    <template v-if="status === 'secondPart'">
      <img class="course"
           :src="require('@/assets/img/liuxuan-psychology/third-stage/course.png')"
           alt=""
      />
    </template>
  </div>
</template>

<script>
  export default {
    name: 'LiuXuanCourseInfo',
    props: {
      status: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .course {
    margin: 0 auto;
    display: block;
    max-width: 1100px;
  }

  .course-first {
    margin-bottom: 104px;
  }

</style>
